module.exports = __webpack_public_path__ + "static/media/cancel-service_6.bf9671e8.png";